import mixins from 'vue-typed-mixins';

import Header from '@/user/components/header/Header.vue';
import BackButton from '@/user/components/header/backButton/BackButton.vue';
import LogoutButton from '@/user/components/header/logoutButton/LogoutButton.vue';
import UserStamp from '@/user/components/userStamp/UserStamp.vue';

import CourseMixin, { Course } from '@/mixins/CourseMixin';
import CourseProgressMixin from '@/user/mixins/CourseProgressMixin';
import RoutesMixin from '@/user/mixins/RoutesMixin';
import UserMixin from '@/user/mixins/UserMixin';

import { USER_STORAGE_KEY } from '@/classes/common/Constants';




export default mixins(CourseMixin, CourseProgressMixin, RoutesMixin, UserMixin).extend({

  name: 'CourseSelect',

  components: {
    Header,
    BackButton,
    LogoutButton,
    UserStamp,
  },

  created(): void {
    this.clearProgresses();
    sessionStorage.removeItem(USER_STORAGE_KEY.STUDY_SECTION_NO);
  },

  methods: {
    selectCourse(course: Course): void {
      this.$router.push({
        name: this.routes.UnitSelect.name,
        params: {
          courseId: String(course.id),
          courseName: course.name
        }
      });
    },
    toStampSelect(): void {
      this.$router.push(this.routes.StampSelect);
    }
  }

});
